import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profile", -1)
const _hoisted_2 = { class: "flex flex-col min-h-screen" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-4" }, "Social account details", -1)
const _hoisted_4 = { class: "flex flex-wrap justify-center gap-5 py-5 w-full" }
const _hoisted_5 = { class: "flex flex-col min-w-[303px]" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "absolute text-secondary-violet" }, "validating...", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "divide-y flex flex-col pt-5" }
const _hoisted_10 = { class: "flex w-full gap-4 pr-5 overflow-clip text-ellipsis" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "font-bold w-full" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col w-full pb-5"
}
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "absolute text-secondary-violet font-normal" }, "validating...", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "flex justify-end gap-3 w-full pt-5"
}
const _hoisted_18 = {
  key: 1,
  class: "font-normal text-sm opacity-70"
}
const _hoisted_19 = {
  key: 0,
  class: "flex flex-row w-1/3 justify-end"
}
const _hoisted_20 = { class: "bg-white dark:bg-primary-black shadow-base rounded-xl-100 flex flex-col py-3 gap-3 rounded-base w-[13rem]" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)

import { ref, computed, onMounted } from "vue"
  import { useUserStore } from "@/store/user"
  import { arrowBackCircle, ellipsisHorizontal } from "ionicons/icons"
  import { IonBackButton, IonButton } from "@ionic/vue"
  import { toastController } from "@ionic/core"
  import { map, includes } from "lodash"
  import jwt from "@/utils/jwt"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import WbMultipleSelect from "@/components/template/ComboBoxContainer.vue"

  // images
  import FacebookIcon from "@/assets/images/social-media/facebook-icon.svg"
  import DribbleIcon from "@/assets/images/social-media/dribble-icon.svg"
  import InstagramIcon from "@/assets/images/social-media/instagram-icon.svg"
  import YoutubeIcon from "@/assets/images/social-media/youtube-icon.svg"
  import BehanceIcon from "@/assets/images/social-media/behance-icon.svg"
  import TiktokIcon from "@/assets/images/social-media/tiktok-icon.svg"
  import LinkedinIcon from "@/assets/images/social-media/linkedin-icon.svg"

  interface SocialAccount {
    media_type: string
    link: string
  }

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionsContainer',
  setup(__props) {

  const userStore = useUserStore()
  const nbf = ref(jwt.generateNBF())

  // initializations
  const profile = computed<any>({
    get: () => userStore.customerDetails.profile,
    set: (val) => userStore.setCustomerDetails({ profile: val }),
  })
  const inputPlatform = ref("")
  const inputLink = ref("")
  const validatingInputLink = ref(false)
  const editConnection = ref("")
  const editInput = ref("")
  const validatingEditInput = ref(false)

  const platforms = [
    {
      icon: FacebookIcon,
      name: "Facebook",
      value: "Facebook",
    },
    {
      icon: InstagramIcon,
      name: "Instagram",
      value: "Instagram",
    },
    {
      icon: YoutubeIcon,
      name: "YouTube",
      value: "YouTube",
    },
    {
      icon: TiktokIcon,
      name: "TikTok",
      value: "TikTok",
    },
    {
      icon: LinkedinIcon,
      name: "LinkedIn",
      value: "LinkedIn",
    },
    {
      icon: BehanceIcon,
      name: "Behance",
      value: "Behance",
    },
    {
      icon: DribbleIcon,
      name: "Dribble",
      value: "Dribble",
    },
  ]
  const connectedSocials = computed<string[]>(() => map(profile.value.socials, (val) => val.media_type))
  const platformOptions = computed(() => platforms.filter((val) => !includes(connectedSocials.value, val.value)))

  /**
   *
   * @param platform - type of platform
   *
   * returns platform icon (string)
   */
  const platformIcon = (platform: string) => {
    const getIcon = platforms.filter((val: any) => val.value === platform)
    return getIcon.length ? getIcon[0].icon : ""
  }

  /**
   *
   * @param url - url (string)
   *
   * returns :true if url is valid else :false
   */
  const isValidURL = (url: string) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ) // fragment locator
    return !!pattern.test(url)
  }

  /**
   * add social account
   */
  const addConnection = async () => {
    validatingInputLink.value = true
    const isValid = isValidURL(inputLink.value)
    if (isValid) {
      let socials = profile.value.socials as SocialAccount[]
      socials = socials.filter((val: any) => true)
      socials.push({
        media_type: inputPlatform.value,
        link: inputLink.value,
      })
      const socialsData = {
        profile: {
          socials: socials,
        },
      }
      await userStore.saveCustomerDetails(nbf.value, socialsData, `${inputPlatform.value} account has been connected`).then((success) => {
        if (success) {
          profile.value.socials.push({
            media_type: inputPlatform.value,
            link: inputLink.value,
          })
        }
      })
      validatingInputLink.value = false
      inputLink.value = ""
      inputPlatform.value = ""
      await userStore.retrieveProfileDetails("socials")
    } else {
      validatingInputLink.value = false
      const toast = await toastController.create({
        message: "Invalid URL",
        duration: 3000,
        position: "top",
        color: "warning",
      })
      await toast.present()
    }
  }

  /**
   *
   * @param event - edit | delete
   * @param index - number
   *
   * handles edit and delete action
   */
  const handleEditAction = async (event: any, index: number) => {
    if (event === "edit") {
      editConnection.value = profile.value.socials[index].media_type
      editInput.value = profile.value.socials[index].link
    } else if (event === "delete") {
      const platform = profile.value.socials[index].media_type
      let socials = profile.value.socials as SocialAccount[]
      socials = socials.filter((val: any, position: number) => position != index)
      await userStore
        .saveCustomerDetails(
          nbf.value,
          {
            profile: {
              socials: socials,
            },
          },
          `${platform} account has been disconnected`
        )
        .then((success) => {
          if (success) profile.value.socials = socials
        })
      await userStore.retrieveProfileDetails("socials")
    }
  }

  /**
   *
   * @param index - index of social account
   *
   * saves changes to link
   */
  const saveEditLink = async (index: number) => {
    validatingEditInput.value = true
    const isValid = isValidURL(editInput.value)
    if (isValid) {
      profile.value.socials[index].link = editInput.value
      const socialsData = {
        profile: {
          socials: profile.value.socials,
        },
      }
      await userStore.saveCustomerDetails(nbf.value, socialsData, "Changes saved")
      validatingEditInput.value = false
      editInput.value = ""
      editConnection.value = ""
      await userStore.retrieveProfileDetails("socials")
    } else {
      validatingEditInput.value = false
    }
  }

  /**
   * initialize social media connections
   */
  onMounted(() => {
    userStore.retrieveProfileDetails("socials")
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab_list = _resolveComponent("ion-fab-list")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton), {
                  class: "text-gray-300 pl-3",
                  text: ``,
                  icon: _unref(arrowBackCircle)
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CardTemplate, { class: "mx-4 my-6" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(WbMultipleSelect, {
                  modelValue: inputPlatform.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputPlatform).value = $event)),
                  name: "platform",
                  data: _unref(platformOptions),
                  "by-value": true,
                  "display-selected-names": true,
                  "input-disabled": true,
                  type: "default",
                  placeholder: "Select a Platform",
                  class: "min-w-[303px]"
                }, null, 8, ["modelValue", "data"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(WbInput, {
                    modelValue: inputLink.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputLink).value = $event)),
                    name: "link",
                    type: "text",
                    placeholder: "https://",
                    class: "w-full"
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
                    [_vShow, validatingInputLink.value]
                  ])
                ]),
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  color: "white",
                  type: "button",
                  "native-type": "button",
                  class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full max-w-[303px]",
                  disabled: !inputPlatform.value.length || !inputLink.value.length || !inputLink.value.includes('https://') || !inputLink.value.includes(inputPlatform.value.toLowerCase()),
                  onClick: addConnection
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 512), [
                [_vShow, _unref(platformOptions).length]
              ]),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profile).socials, (data, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${index}_id`,
                    class: "flex justify-between items-center space-y-10 py-5"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      (data.media_type && data.media_type.length && platformIcon(data.media_type).length)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "rounded-lg px-4 py-2 h-12 w-14 bg-primary-violet",
                            src: platformIcon(data.media_type),
                            alt: ""
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(data.media_type || "...") + " ", 1),
                        (data.media_type && data.media_type.length && editConnection.value === data.media_type)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(WbInput, {
                                modelValue: editInput.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editInput).value = $event)),
                                name: "editLink",
                                type: "text",
                                placeholder: "https://",
                                class: "w-full font-normal"
                              }, null, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_16, 512), [
                                [_vShow, validatingEditInput.value]
                              ]),
                              (data.media_type && data.media_type.length && editConnection.value === data.media_type)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_unref(IonButton), {
                                      expand: "block",
                                      color: "white",
                                      "native-type": "button",
                                      type: "button",
                                      class: "w-full max-w-[158px] h-[45px] rounded-[4px] bg-primary-violet text-white font-medium shadow-base hover:bg-white hover:text-black",
                                      disabled: !editInput.value.length || editInput.value === data.link || !editInput.value.includes('https://') || !editInput.value.includes(data.media_type.toLowerCase()),
                                      onClick: ($event: any) => (saveEditLink(index))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Save ")
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]),
                                    _createVNode(_unref(IonButton), {
                                      expand: "block",
                                      color: "white",
                                      "native-type": "button",
                                      type: "button",
                                      class: "w-full max-w-[158px] h-[45px] rounded-[4px] bg-white text-black font-medium shadow-sm hover:bg-primary-violet/20 hover:text-white",
                                      onClick: _cache[3] || (_cache[3] = () => (editConnection.value = ''))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Cancel ")
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(data.link || "..."), 1))
                      ])
                    ]),
                    (!data.media_type || !data.media_type.length || editConnection.value !== data.media_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_ion_fab, {
                            horizontal: "end",
                            class: "relative -mt-[40px] -mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_fab_button, {
                                color: "light",
                                class: "px-2 py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _unref(ellipsisHorizontal) }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_fab_list, {
                                side: "start",
                                class: "z-30"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", {
                                      class: "hover:bg-primary-violet/20 py-1 pl-3",
                                      onClick: ($event: any) => (handleEditAction('edit', index))
                                    }, "Edit", 8, _hoisted_21),
                                    _createElementVNode("span", {
                                      class: "hover:bg-primary-violet/20 py-1 pl-3",
                                      onClick: ($event: any) => (handleEditAction('delete', index))
                                    }, "Delete", 8, _hoisted_22)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _hoisted_23
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})